import React, { useEffect, useState } from "react"
import styles from "./index.module.css"
import { Card, Typography, Row, Col, Modal, Flex, Button,Spin } from "antd"

const { Title, Text } = Typography

export const WaiverDetails = ({isLoading,setIsLoading, recordData, visible, onCancel, width = 1000 }) => {
  console.log(isLoading, "isLoadingisLoading")
  const [fileList, setFileList] = useState([])
  const [pdfUrls, setPdfUrls] = useState([])
  const [currentWaiverIndex, setCurrentWaiverIndex] = useState(0)
  useEffect(() => {
    const waivers = [...(recordData?.signed_documents || []), ...(recordData?.unsigned_documents || [])] || []
    if (waivers.length > 0) {
      const now = new Date()
      const initialFileObjects = waivers.map((waiverItem, index) => {
        const fileName = waiverItem?.split("/").pop() || "document.pdf"
        return {
          uid: `existing-${Date.now()}-${index}`,
          lastModified: now.getTime(),
          lastModifiedDate: now.toISOString(),
          name: fileName,
          type: "application/pdf",
          percent: 0,
          status: "uploading",
          url: waiverItem,
          index: index,
          key: index
        }
      })

      setFileList(initialFileObjects)

      // Load all documents
      const fetchDocuments = async () => {
        try {
          const filePromises = waivers.map(async (waiverItem, index) => {
            const fileName = waiverItem?.split("/").pop() || "document.pdf"

            const response = await fetch(waiverItem)
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }

            // Get the blob and create a file object
            const blob = await response.blob()
            const file = new File([blob], fileName, {
              type: blob.type || "application/pdf",
              lastModified: now.getTime()
            })

            // Create the final file object with all properties
            return {
              ...initialFileObjects[index],
              size: blob.size,
              status: "done",
              originFileObj: file,
              index: index,
              key: index
            }
          })
          const fileObjects = await Promise.all(filePromises)
          setFileList(fileObjects)

          // Set PDF URLs for all documents
          const pdfObjectUrls = fileObjects.map((fileObj) => URL.createObjectURL(fileObj.originFileObj))
          setPdfUrls(pdfObjectUrls)
         setIsLoading(false)
          // Clean up function to revoke object URLs on unmount
          return () => {
            pdfObjectUrls.forEach((url) => URL.revokeObjectURL(url))
          }
        } catch (error) {
          console.error("Error fetching documents:", error)
          // Update file list with error state
          setFileList(
            initialFileObjects.map((obj) => ({
              ...obj,
              status: "error",
              error: "Failed to load document"
            }))
          )
        }
      }
      fetchDocuments()
    }
  }, [recordData?.signed_documents, recordData?.unsigned_documents])

  // Reset current index when file list changes
  useEffect(() => {
    setCurrentWaiverIndex(0)
  }, [fileList])

  const handlePrevious = () => {
    setCurrentWaiverIndex((prev) => (prev > 0 ? prev - 1 : 0))
  }

  const handleNext = () => {
    setCurrentWaiverIndex((prev) => (prev < fileList.length - 1 ? prev + 1 : prev))
  }

  const modalContent = (
    <Spin spinning={isLoading} >
    <div className={styles.waiverDetailsContainer}>
      <Title level={3} className="mb-s">
        Guest Details
      </Title>
      <Row gutter={[24, 0]}>
        <Col xs={24} lg={14}>
          <div>
            {pdfUrls.length > 0 && (
              <div className={styles.pdfPreviewContainer}>
                <div className={styles.pdfViewer}>
                  <Flex justify="space-between" className={`mb-xs`}>
                    <div>
                      Document {currentWaiverIndex + 1}: {fileList[currentWaiverIndex]?.name || `Document ${currentWaiverIndex + 1}`}
                    </div>
                    <div>
                      {currentWaiverIndex + 1} of {fileList.length} waivers
                    </div>
                  </Flex>
                  <object data={pdfUrls[currentWaiverIndex]} type="application/pdf" className={styles.pdfObject}>
                    <div style={{ padding: "20px", textAlign: "center" }}>
                      Unable to display PDF preview. Please download the file to view it.
                    </div>
                  </object>
                </div>
              </div>
            )}
            {/* Legal Text & Checkbox */}
          </div>
          <Flex justify="end" gap={12} className="mt-xl">
            <Button color="primary" variant="outlined" onClick={handlePrevious} disabled={fileList.length <= 1 || currentWaiverIndex === 0}>
              Previous
            </Button>
            <Button
              color="primary"
              variant="solid"
              onClick={handleNext}
              disabled={fileList.length <= 1 || currentWaiverIndex === fileList.length - 1}
            >
              Next
            </Button>
          </Flex>
        </Col>

        <Col xs={24} lg={10}>
          <Card>
            {/* <Title level={4}>Guest Details</Title> */}
            <div className={`${styles.detailItem} mt-xs`}>
              <div className={styles.label}>
                <Text className={styles.detailLabel}>Full Name</Text>
              </div>
              <div className={styles.value}>
                <Text className={styles.detailValue}>{recordData?.full_name || "-"}</Text>
              </div>
            </div>
            {recordData?.guest_email && (
              <div className={`${styles.detailItem}`}>
                <div className={styles.label}>
                  <Text className={styles.detailLabel}>Email</Text>
                </div>
                <div className={styles.value}>
                  <Text className={styles.detailValue}>{recordData?.guest_email || "-"}</Text>
                </div>
              </div>
            )}
            {recordData?.phone_number && (
              <div className={`${styles.detailItem}`}>
                <div className={styles.label}>
                  <Text className={styles.detailLabel}>Phone</Text>
                </div>
                <div className={styles.value}>
                  <Text className={styles.detailValue}>{recordData?.phone_number || "-"}</Text>
                </div>
              </div>
            )}

            <div className={styles.detailItem}>
              <div className={styles.label}>
                <Text className={styles.detailLabel}>Date of Birth</Text>
              </div>
              <div className={styles.value}>
                <Text className={styles.detailValue}>{recordData?.birthdate || "-"}</Text>
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.label}>
                <Text className={styles.detailLabel}>Signed By</Text>
              </div>
              <div className={styles.value}>
                <Text className={styles.detailValue}>{recordData?.signed_by || "Guardian"}</Text>
              </div>
            </div>
            <div className={styles.detailItem}>
              <div className={styles.label}>
                <Text className={styles.detailLabel}>IP Address:</Text>
              </div>
              <div className={styles.value}>
                <Text className={styles.detailValue}>{recordData?.ip_address || "-"}</Text>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
    </Spin>
  )

  return (
    <Modal open={visible} onCancel={onCancel} footer={null} width={width} centered className={styles.waiverModal}>
      {modalContent}
    </Modal>
  )
}
